/* eslint-disable react-refresh/only-export-components */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import PageTabs from '@/components/shared/PageTabs';
import { useTranslator } from '@/hooks/useTranslator';

export const Route = createFileRoute(
  '/(client)/constants-mapping/(pages)/(list)',
)({
  component: ConstantsMappingLayout,
});

function ConstantsMappingLayout() {
  const { getTranslation: t } = useTranslator({ page: 'constantsMapping' });

  return (
    <div className='flex flex-col flex-1 min-h-0 overflow-hidden'>
      <PageTabs
        tabs={[
          {
            key: 'companies',
            label: t('tabs.companies'),
            to: '/constants-mapping/companies',
          },
          {
            key: 'materials',
            label: t('tabs.materials'),
            to: '/constants-mapping/materials',
          },
          {
            key: 'product-types',
            label: t('tabs.productTypes'),
            to: '/constants-mapping/product-types',
          },
        ]}
        mode='path'
        moreLabel={t('tabs.more')}
      />
      <PageContainer>
        <Outlet />
      </PageContainer>
    </div>
  );
}
